import { useCallback, useEffect } from 'react';
import qs from 'query-string';

import useXHR from './useXHR';

const useGet = ({ url, query, onMount, preserveLast }) => {
  const [state, req, setRes] = useXHR(onMount, preserveLast);
  const queryString = query ? qs.stringify(query) : null;

  const send = useCallback(
    ({ url: newUrl, query: newQuery } = {}) => {
      const latestUrl = newUrl || url;
      const latestQuery = newQuery ? qs.stringify(newQuery) : queryString;

      const urlToOpen = latestQuery ? `${latestUrl}?${latestQuery}` : latestUrl;

      const token = localStorage.getItem('token');
      req.open('GET', urlToOpen);
      if (token) {
        req.setRequestHeader('Authorization', `Bearer ${token}`);
      }
      req.send();
    },
    [url, queryString, req]
  );

  useEffect(() => {
    if (onMount) {
      send();
    }
    return () => req.abort();
  }, [onMount, send, req]);

  return [state, send, setRes];
};

export default useGet;
